import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { useHomeStats } from '@/hooks/useApi.js';

const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    location: 'Mumbai',
    avatar: 'PS',
    rating: 5,
    text: 'Amazing collection and super fast delivery! The quality exceeded my expectations. Will definitely shop again.',
  },
  {
    id: 2,
    name: 'Rahul Verma',
    location: 'Delhi',
    avatar: 'RV',
    rating: 5,
    text: 'Best place for ethnic wear. Found the perfect kurta set for my wedding. Great customer service too!',
  },
  {
    id: 3,
    name: 'Ananya Patel',
    location: 'Bangalore',
    avatar: 'AP',
    rating: 5,
    text: 'Love the kids collection! My daughter is so happy with her new dresses. Affordable and trendy.',
  },
];

export function Testimonials() {
  const { data: stats } = useHomeStats();
  
  return (
    <section className="container mx-auto px-4 py-10">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-8"
      >
        <h2 className="text-2xl md:text-3xl font-bold mb-2">What Our Customers Say</h2>
        <p className="text-muted-foreground">Join thousands of happy shoppers</p>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-6">
        {testimonials.map((testimonial, index) => (
          <motion.div
            key={testimonial.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            className="bg-card rounded-xl p-6 shadow-card relative"
          >
            <Quote className="absolute top-4 right-4 h-8 w-8 text-primary/10" />
            
            {/* Rating */}
            <div className="flex items-center gap-0.5 mb-4">
              {Array.from({ length: testimonial.rating }).map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-rating text-rating" />
              ))}
            </div>

            {/* Text */}
            <p className="text-foreground/80 mb-4 line-clamp-4">"{testimonial.text}"</p>

            {/* Author */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center font-semibold text-primary text-sm">
                {testimonial.avatar}
              </div>
              <div>
                <p className="font-medium">{testimonial.name}</p>
                <p className="text-sm text-muted-foreground">{testimonial.location}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Trust badges */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="flex flex-wrap items-center justify-center gap-8 mt-10 py-6 border-t border-b"
      >
        <div className="text-center">
          <p className="text-2xl lg:text-3xl font-bold text-primary">
            {stats?.totalCustomers ? `${stats.totalCustomers}+` : '0+'}
          </p>
          <p className="text-sm text-muted-foreground">Happy Customers</p>
        </div>
        <div className="text-center">
          <p className="text-2xl lg:text-3xl font-bold text-primary">
            {stats?.averageRating ? `${stats.averageRating}★` : '0★'}
          </p>
          <p className="text-sm text-muted-foreground">Average Rating</p>
        </div>
        <div className="text-center">
          <p className="text-2xl lg:text-3xl font-bold text-primary">
            {stats?.totalProducts ? `${stats.totalProducts}+` : '0+'}
          </p>
          <p className="text-sm text-muted-foreground">Products</p>
        </div>
        <div className="text-center">
          <p className="text-2xl lg:text-3xl font-bold text-primary">5+</p>
          <p className="text-sm text-muted-foreground">Cities</p>
        </div>
      </motion.div>
    </section>
  );
}
